<template>
	<sf-modal-layout size="xl" :title="getMessage_('SWCC000998')" ref="modal" :show="showCommCdLangModal_" :closeModal="closeModal">
		<div class="sf-flex-column h-100">
			<div class="sf-col sf-col-4">
				<sf-card class="p-0 h-100 card_bg">
					<div class="sf-search-layout__body__container">
						<sf-search-layout>
							<el-row :gutter="20">
								<el-col :span="6">
									<sf-input-group :label="getMessage_('SWCC001002')" :inputValue="langId" :onChange="e => onChange('langId', e)" />
								</el-col>
								<el-col :span="6">
									<sf-input-group :label="getMessage_('SWCC001003')" :inputValue="langVal" :onChange="e => onChange('langVal', e)" />
								</el-col>
							</el-row>
							<template slot="button">
								<sf-button line icon="search" :onClick="search" v-if="isButton_(scrId, 'CR')">{{ getButtonMsg_(scrId, 'CR') }}</sf-button>
							</template>
						</sf-search-layout>
					</div>
				</sf-card>
			</div>
			<div class="sf-col sf-col-20">
				<sf-card class="p-0 border-0 bg-transparent h-100">
					<comm-cd-lang-table ref="table" :scrId="scrId" @closeModal="closeModal" />
				</sf-card>
			</div>
		</div>
		<template v-slot:footer>
			<sf-button line :onClick="() => closeModal()">
				{{ getMessage_('SWCC000343') }}
			</sf-button>
		</template>
	</sf-modal-layout>
</template>

<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@common/CommonCode/store/helpers';
import { CommCdLangTable } from '@common/CommonCode/Content/Table';

export default {
	props: {
		scrId: { type: String, default: '' }
	},
	data() {
		return {
			screen: {}
		};
	},
	created() {
		this.screen = this.screenArray.get(this.scrId);
	},
	components: {
		CommCdLangTable
	},
	created() {
		this.getCommCodes_({ key: 'commLangType', codeType: 'COMM_LANG_TYPE' })
			.then(() => {
				this.commLangType.forEach(row => {
					this.gridLangCdype.push({
						label: row.commCdName,
						value: row.commCd
					});
				});
			})
			.catch(error => {
				this.$sf_toast({
					type: 'error',
					message: error.message
				});
				Promise.reject(error);
			});

		this.getCommCodes_({ key: 'msgTypes', codeType: 'MSG_TYPE' })
			.then(() => {
				this.msgTypes.forEach(row => {
					this.gridMsgTypes.push({
						label: row.commCdName,
						value: row.commCd
					});
				});
			})
			.catch(error => {
				this.$sf_toast({
					type: 'error',
					message: error.message
				});
				Promise.reject(error);
			});
	},
	data() {
		return {
			langId: null,
			langVal: null
		};
	},
	computed: {
		...rootComputed,
		...serviceComputed
	},
	methods: {
		...rootMethods,
		...serviceMethods,

		search() {
			const { currentPage, pageUnit } = this.commCdLangModal.groups;
			this.$sf_toggleLoading(true);
			this.selectCommCdLangList_({ langId: this.langId, langVal: this.langVal, currentPage, pageUnit }).finally(() => {
				this.$sf_toggleLoading(false);
			});
		},
		onChange(key, value) {
			this[key] = value;
		},
		closeModal() {
			this.$emit('setName', this.$refs.table.selectedRow);

			this.langId = null;
			this.langVal = null;

			this.$refs.table.resetTable();

			this.SET({
				key: 'commCdLangModal',
				value: {
					show: false,
					isButtonOpened: false,
					codeType: '',
					groups: {
						currentPage: 1,
						pageUnit: 10,
						totalSize: 0
					}
				}
			});
		}
	}
};
</script>

<style></style>
